import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tabs, Tab, Paper } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import DetailsTab from './Tabs/DetailsTab';
import ActivityTab from './Tabs/ActivityTab';
import CalendrierTab from './Tabs/CalendrierTab';
import PartiesTab from './Tabs/PartiesTab';
import '../../../components/sinistreSection/sinistreSection.css';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from "react-redux";
import HistoryTab from "./Tabs/HistoryTab";
import FilesTab from "./Tabs/FilesTab";
import { createListInvestigationAction, getAllInvestigationActionsEnum } from "../../../store/action/investigationAction";
import { createInvestigation, getAllInvestigation } from "../../../store/action/investigation";
import { getInvestigationActionsByInvestigationId } from "../../../store/action/investigationAction";
import { Navigate, useNavigate } from "react-router-dom";
import { format } from 'date-fns';

const useStyles = makeStyles((theme) => ({
    titer: {
        fontFamily: 'Poppins',
        fontSize: '13px',
        fontWeight: 600,
        lineHeight: '19.5px',
        textAlign: 'center',
        background: 'rgba(255, 255, 255, 0.35)',
        color: 'rgba(63, 66, 84, 0.64)',
    },
    item: {
        fontFamily: 'Poppins',
        fontSize: '12.81px',
        fontWeight: 500,
        lineHeight: '19.22px',
        textAlign: 'left',
        color: 'rgba(181, 181, 195, 1)',
        padding: '3px',
    },
    paper: {
        width: "100%",
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.06)',
    },
    backButton: {
        color: 'rgba(63, 66, 84, 0.64)',
    },
    title: {
        fontFamily: 'Poppins',
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: '30px',
        textAlign: 'center',
        color: 'rgba(63, 66, 84, 0.64)',
        margin: '20px 0',
    },
}));

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div style={{ width: "100%", background: 'rgba(255, 255, 255, 1)' }}>
                    {children}
                </div>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const CreateInvestigation = ({ handleBackInvestigation, selectedInvestigation,readOnly,selectedClaimNumber }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState(0);
    const [completedTabs, setCompletedTabs] = useState([]);
    const [claim, setClaim] = useState({});
    const [listOfParties, setListOfParties] = useState({});
    const investigationActionReducer = useSelector((state) => state.investigationActionReducer);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        claimNumber: selectedClaimNumber ,
        title: '',
        description: '',
        responsable: '',
        assigne: '',
        status: '',
        priority: '',
        dateCreation: new Date().toISOString(), // Set createdAt to now
        dateMAJ: new Date().toISOString(),
        causesAssociees: [],
        formulaires: [],
        tasks: [],
        taskSummary: {
            total: 0,
            completed: 0,
            inProgress: 0,
            notStarted: 0,
        },
    });

    const [hasFetchedData, setHasFetchedData] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            console.log('Fetching data...');
            if (selectedInvestigation) {
                await dispatch(getInvestigationActionsByInvestigationId(selectedInvestigation._id));
                const investigationActionsById = investigationActionReducer.investigationActionsByInvestigationId;
                const mappedData = await mapReceivedDataToFormData(selectedInvestigation, investigationActionsById);
                setFormData(mappedData);
            }
        };
    
        fetchData();
    }, [selectedInvestigation, dispatch, investigationActionReducer]);
    

    const mapReceivedDataToFormData = async (data, listOfInvestigationActionById) => {
        const mappedData = {
            claimNumber: data.claimNumber || '',
            title: data.titre || '',
            description: data.commentaires || '',
            responsable: data.userID || '',
            assigne: data.assigne || '',
            status: data.state || '',
            priority: data.priority || '',
            dateCreation: data.createdAt ? format(new Date(data.createdAt), 'yyyy-MM-dd') : '',
            dateMAJ: data.updatedAt ? format(new Date(data.updatedAt), 'yyyy-MM-dd') : '',
            causesAssociees: data.listeCause || [],
            formulaires: data.listeFormID || [],
            tasks: (listOfInvestigationActionById || []).map(action => ({
                id: action.idAction,
                title: action.actionDescription,
                status: action.state,
                priority: action.priority,
                plannedDate: action.actionDate ? format(new Date(action.actionDate), 'yyyy-MM-dd') : '',
            })) || [],
            taskSummary: {
                total: listOfInvestigationActionById.length,
                completed: listOfInvestigationActionById.filter(task => task.state === 'Completed').length,
                inProgress: listOfInvestigationActionById.filter(task => task.state === 'In Progress').length,
                notStarted: listOfInvestigationActionById.filter(task => task.state === 'Not Started').length,
            },
        };
        return mappedData;
    };

    const handleFormChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const updateFormData = (newData) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            ...newData
        }));

    };


    const handleDropdownChange = (name, selectedOptions) => {
        setFormData({
            ...formData,
            [name]: selectedOptions,
        });
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const handleClaimNumberChange = (newClaim) => {
        updateFormData({claimNumber: newClaim.claimNumber});
        setListOfParties(newClaim.involvedParties);
        setClaim(newClaim);
    };

    const handleNext = () => {
        setCompletedTabs([...completedTabs, activeTab]);
        setActiveTab(activeTab + 1);
    };

    const handlePrevious = () => {
        setActiveTab(activeTab - 1);
    };

    const handleSave = async () => {

        // Prepare the investigation object
        const transformedInvestigation = {
            claimNumber: formData.claimNumber,
            commentaires: formData.description,
            titre: formData.title,
            userID: formData.responsable,
            assigne: formData.assigne,
            state: formData.status,
            priority: formData.priority,
            listeInvestigationAction: [],
            listeCause: formData.causesAssociees,
            listeFormID: formData.formulaires,
        };

        // Prepare the investigation actions
        const investigationActions = formData.tasks.map(task => ({
            idAction: task.id,
            idInvestigation: "",
            actionDescription: task.title,
            state: task.status,
            priority: task.priority,
            actionDate: new Date(task.plannedDate),
            actionBy: formData.assigne,
        }));

        try {
            const lastInvestigation = await dispatch(createInvestigation(transformedInvestigation));
            const updatedInvestigationActions = investigationActions.map(action => ({
                ...action,
                idInvestigation: lastInvestigation ? lastInvestigation._id : "",
            }));


            await dispatch(createListInvestigationAction(updatedInvestigationActions));
            console.log("Investigation and actions saved successfully.");
            navigate('/investigations', { replace: true });
            navigate(0);

        } catch (error) {
            console.error('Error saving investigation and actions:', error);
        }
    };

    return (
        <div>
            <Paper className={classes.paper}>
                <div style={{display: 'flex', alignItems: 'center', marginTop: '20px', marginBottom: '20px'}}>
                    <IconButton onClick={handleBackInvestigation} aria-label="back" className={classes.backButton}
                                style={{marginLeft: '10px', marginBottom: '50px', marginTop: '30px'}}>
                        <ArrowBack/>
                    </IconButton>
                    <h2 style={{
                        marginLeft: '20px',
                        marginBottom: '50px',
                        marginTop: '30px',
                        fontSize: '20px',
                        fontWeight: 'bold'
                    }}>
                        {readOnly ? 'Consultation d’une investigation' : 'Création d’une nouvelle investigation'}
                        
                    </h2>
                </div>
            </Paper>


            <div className="tabs-container">
                <Tabs value={activeTab} onChange={handleTabChange} sx={{marginTop: "40px", variant: "fullWidth"}}>
                    <Tab sx={{
                        textTransform: 'none',
                        height: 50,
                        fontFamily: 'Poppins',
                        fontSize: '13px',
                        fontWeight: 600,
                        lineHeight: '19.5px',
                        textAlign: 'center',
                        background: 'rgba(255, 255, 255, 0.35)',
                        color: 'rgba(63, 66, 84, 0.64)',
                        marginRight: '5px'
                    }} {...a11yProps(0)} label="Details"/>
                    <Tab sx={{
                        textTransform: 'none',
                        height: 50,
                        fontFamily: 'Poppins',
                        fontSize: '13px',
                        fontWeight: 600,
                        lineHeight: '19.5px',
                        textAlign: 'center',
                        background: 'rgba(255, 255, 255, 0.35)',
                        color: 'rgba(63, 66, 84, 0.64)',
                        marginRight: '5px'
                    }} {...a11yProps(1)} label="Activités"/>
                    <Tab sx={{
                        textTransform: 'none',
                        height: 50,
                        fontFamily: 'Poppins',
                        fontSize: '13px',
                        fontWeight: 600,
                        lineHeight: '19.5px',
                        textAlign: 'center',
                        background: 'rgba(255, 255, 255, 0.35)',
                        color: 'rgba(63, 66, 84, 0.64)',
                        marginRight: '5px'
                    }} {...a11yProps(2)} label="Calendrier"/>
                    <Tab sx={{
                        textTransform: 'none',
                        height: 50,
                        fontFamily: 'Poppins',
                        fontSize: '13px',
                        fontWeight: 600,
                        lineHeight: '19.5px',
                        textAlign: 'center',
                        background: 'rgba(255, 255, 255, 0.35)',
                        color: 'rgba(63, 66, 84, 0.64)',
                        marginRight: '5px'
                    }} {...a11yProps(3)} label="Tiers"/>
                    <Tab sx={{
                        textTransform: 'none',
                        height: 50,
                        fontFamily: 'Poppins',
                        fontSize: '13px',
                        fontWeight: 600,
                        lineHeight: '19.5px',
                        textAlign: 'center',
                        background: 'rgba(255, 255, 255, 0.35)',
                        color: 'rgba(63, 66, 84, 0.64)',
                        marginRight: '5px'
                    }} {...a11yProps(4)} label="Documents"/>
                    <Tab sx={{
                        textTransform: 'none',
                        height: 50,
                        fontFamily: 'Poppins',
                        fontSize: '13px',
                        fontWeight: 600,
                        lineHeight: '19.5px',
                        textAlign: 'center',
                        background: 'rgba(255, 255, 255, 0.35)',
                        color: 'rgba(63, 66, 84, 0.64)',
                        marginRight: '5px'
                    }} {...a11yProps(5)} label="Historique"/>
                </Tabs>
            </div>
            <div className="content">
                <CustomTabPanel value={activeTab} index={0}>
                    <DetailsTab onClaimNumberChange={handleClaimNumberChange}
                                claimNumber={selectedClaimNumber}
                                handleNext={handleNext} formData={formData} handleFormChange={handleFormChange}
                                handleDropdownChange={handleDropdownChange} 
                                readOnly={readOnly}/>
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={1}>
                    <ActivityTab handlePrevious={handlePrevious} handleNext={handleNext}
                                 formData={formData} handleFormChange={updateFormData}
                                 readOnly={readOnly}/>
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={2}>
                    <CalendrierTab handlePrevious={handlePrevious} handleNext={handleNext}
                                   formData={formData} handleFormChange={handleFormChange}
                                   readOnly={readOnly}/>
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={3}>
                    <PartiesTab listOfParties={listOfParties || []} handlePrevious={handlePrevious}
                                handleNext={handleNext} formData={formData} handleFormChange={handleFormChange}
                                readOnly={readOnly}/>
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={4}>
                    <FilesTab handlePrevious={handlePrevious} handleNext={handleNext}
                              formData={formData} handleFormChange={handleFormChange}
                              readOnly={readOnly}/>
                </CustomTabPanel>
                <CustomTabPanel value={activeTab} index={5}>
                    <HistoryTab handleSave={handleSave}
                                formData={formData} handleFormChange={handleFormChange}
                                readOnly={readOnly}/>
                </CustomTabPanel>
            </div>
        </div>
    );
};

CreateInvestigation.propTypes = {
    handleBackInvestigation: PropTypes.func.isRequired
};

export default CreateInvestigation;
